import { createContext } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import RankingScreen from './containers/RankingScreen';
import FavoritosScreen from './containers/FavoritosScreen';
import FavoritoSearchScreen from './containers/FavoritoSearchScreen';
import EventoListScreen from './containers/EventoListScreen';
import EventoDetailScreen from './containers/EventoDetailScreen';
import CompeticionScreen from './containers/CompeticionScreen';
import ResultadoScreen from './containers/ResultadoScreen';
import TodosScreen from './containers/TodosScreen';
import Notificaciones from './components/Notificaciones';
import MsgNetError from './components/MsgNetError';
import LocationListScreen from './containers/LocationListScreen';
import LocationDetailScreen from './containers/LocationDetailScreen';
import CompeticionGps from './containers/CompeticionGps';
import ScrapeableScreen from './containers/ScrapeableScreen';
import AltimetriaLEDScreen from './containers/AltimetriaLEDScreen';
import AltimetriaLEDMockScreen from './containers/AltimetriaLEDMockScreen';
import * as serviceWorker from './registerServiceWorker';
import CONFIG from './config';
import './tailwind.css';

// Inicializar Firebase
const firebaseConfig = {
  apiKey: CONFIG.FIREBASE_APIKEY,
  projectId: CONFIG.FIREBASE_PROJECTID,
  messagingSenderId: CONFIG.FCM_SENDER_ID,
  appId: CONFIG.FIREBASE_APPID
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Crear contexto de Firebase para usar en componentes
export const FirebaseContext = createContext(null);

// FCM Source para notificaciones
const FcmSource = {
  listener: () => { },
  subscribe: (fn) => {
    FcmSource.listener = fn;
  }
};

// Inicializar Firebase Cloud Messaging
window.FCM_TOKEN = null;
try {
  const messaging = getMessaging(app);

  // Solicitar permisos de notificación
  Notification.requestPermission().then((permission) => {
    if (permission === 'granted') {
      // Obtener token FCM
      getToken(messaging, { vapidKey: CONFIG.FCM_PUBLIC_KEY })
        .then((token) => {
          window.FCM_TOKEN = token;
        })
        .catch((error) => {
          console.error('Error getting FCM token:', error);
        });
    }
  });

  // Escuchar mensajes en primer plano
  onMessage(messaging, (payload) => {
    return FcmSource.listener(payload);
  });
} catch (e) {
  console.error('FCM initialization error:', e);
}

// Google Analytics
window['GoogleAnalyticsObject'] = 'ga';
window['ga'] = window['ga'] || function () {
  (window['ga'].q = window['ga'].q || []).push(arguments);
};

// Función para trackear páginas (se puede usar con useEffect en componentes)
export const trackPageView = (pathname, search = '') => {
  if (typeof window.ga === 'function') {
    window.ga('set', 'page', pathname + search);
    window.ga('send', 'pageview');
  }
};

const root = createRoot(document.getElementById('root'));
root.render(
  <FirebaseContext.Provider value={{ app, db }}>
    <div className="min-h-screen bg-gray-900 text-gray-100">
      <Notificaciones fcm={FcmSource} />
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path='/' element={<EventoListScreen />} />
          <Route path='/:eventoId' element={<EventoDetailScreen />} />
          <Route path='/:eventoId/locations' element={<LocationListScreen />} />
          <Route path='/:eventoId/location/:locationId' element={<LocationDetailScreen />} />
          <Route path='/competicion/:competicionId' element={<CompeticionScreen />} />
          <Route path='/competicion/:competicionId/favoritos' element={<FavoritosScreen />} />
          <Route path='/competicion/:competicionId/gps' element={<CompeticionGps />} />
          <Route path='/competicion/:competicionId/ranking' element={<RankingScreen />} />
          <Route path='/competicion/:competicionId/ranking/:rankingId' element={<RankingScreen />} />
          <Route path='/competicion/:competicionId/buscar' element={<FavoritoSearchScreen />} />
          <Route path='/competicion/:competicionId/dorsal/:dorsal' element={<ResultadoScreen />} />
          <Route path='/competicion/:competicionId/todos' element={<TodosScreen />} />
          <Route path='/competicion/:competicionId/control/:controlId' element={<CompeticionScreen />} />
          <Route
            path="/scrap/competicion/:competicionId"
            element={<ScrapeableScreen />}
          />
          <Route
            path="/led/altimetria/:competicionId"
            element={<AltimetriaLEDScreen />}
          />
          <Route
            path="/led/altimetria-mock"
            element={<AltimetriaLEDMockScreen />}
          />
          {/* 404 */}
          <Route path='*' element={<MsgNetError />} />
        </Routes>
      </BrowserRouter>
    </div>
  </FirebaseContext.Provider>
);

serviceWorker.default();